const SearchBtn = (props) => {
    let {label} = props

    return (
        <button className="search-btn">{label}</button>
    )
}

export default SearchBtn